import { render, staticRenderFns } from "./HeroLivePreview.vue?vue&type=template&id=0fcf9130&scoped=true&"
import script from "./HeroLivePreview.vue?vue&type=script&lang=js&"
export * from "./HeroLivePreview.vue?vue&type=script&lang=js&"
import style0 from "./HeroLivePreview.vue?vue&type=style&index=0&id=0fcf9130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf9130",
  null
  
)

export default component.exports